import GerarAuditoriaItemDto from "./GerarAuditoriaItemDto";

export default class GerarAuditoriaDto {
    itens: GerarAuditoriaItemDto[] = [];
    sortearUsuarios: boolean = false;
}